import Linkify from 'react-linkify';
import React, { useContext } from 'react';
import get from 'lodash/get';
import { QuestionStyleContext } from '../../question-style-context';
import { type QuestionType } from '../../reducers';
import { LabelMedium } from 'baseui/typography';
const renderInputDesc = (question: QuestionType) => {
  const limit = get(question, 'limit');
  const questionType = question?.type;
  if (questionType === 'select') {
    if (limit === -1) {
      return `(no limit)`;
    }
    if (limit) {
      return `(select ${limit > 1 ? `up to ${limit}` : 'one option'})`;
    }
  }
  return '';
};
const QuestionTitle = ({
  question
}: {
  question: QuestionType;
}) => {
  const {
    questionDecorator,
    requiredHintRenderer,
    questionTitleStyles
  } = useContext(QuestionStyleContext);
  return <LabelMedium overrides={questionTitleStyles ? {
    Block: {
      style: questionTitleStyles
    }
  } : undefined}>
      <Linkify componentDecorator={questionDecorator}>
        {`${question.question || '...'} ${renderInputDesc(question)}`}
      </Linkify>{' '}
      {requiredHintRenderer(question.isRequired)}
    </LabelMedium>;
};
export default QuestionTitle;